import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_SALE_HISTORY} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryWithRouteParam, ThunkApi} from '../interfaces'

import navigateToRoute from './navigateToRoute'

type NavigateToSaleHistoryParam = LocationChangeHistoryWithRouteParam

/** 판매내역 */
const navigateToSaleHistory = createAsyncThunk<void, NavigateToSaleHistoryParam, ThunkApi<unknown>>(
    'navigateTo/sale/history',
    ({historyType = 'PUSH', routeBased = false}, {dispatch}) => {
        if (routeBased) {
            dispatch(navigateToRoute({historyType, path: ROUTER_ORDER_SALE_HISTORY.MAIN.getPath()}))
        } else {
            changeBrowserLocation({
                type: historyType,
                url: ROUTER_ORDER_SALE_HISTORY.MAIN.getHref(),
            })
        }
    },
)

export default navigateToSaleHistory
